<template>
  <div class="home">
    <section class="hero" :class="'hero--' + site">
      <div class="hero__shade"></div>
      <div class="hero__inner">
        <div class="t-eyebrow hero__eyebrow">{{ hero.eyebrow }}</div>
        <h1 class="hero__title">{{ hero.title }}</h1>
        <p class="hero__lead">{{ info.tagline }}</p>
      </div>
      <div class="hero-book">
        <Calendar />
      </div>
      <a href="#sections" class="hero__scroll">Крутите вниз</a>
    </section>

    <div id="sections"></div>

    <section class="about">
      <div class="wrap about__grid">
        <div v-reveal>
          <div class="t-eyebrow">{{ site === 'abaata' ? 'История' : 'Об отеле' }}</div>
          <h2 class="h2">{{ aboutTitle }}</h2>
          <p v-for="(p, i) in about" :key="i" class="about__text">{{ p }}</p>
        </div>
        <div v-if="site === 'abaata'" v-reveal="120" class="about__years">
          <div v-for="y in years" :key="y.year" class="about__year"><b>{{ y.year }}</b><span>{{ y.text }}</span></div>
        </div>
        <div v-else v-reveal="120" class="about__facts">
          <div v-for="f in factsList" :key="f.text" class="about__fact"><b>{{ f.value }}</b><span>{{ f.text }}</span></div>
        </div>
      </div>
    </section>

    <section
      v-for="b in blocks"
      :key="b.key"
      class="block"
      :class="{ 'block--dark': b.dark, 'block--amari-light': b.dark && site === 'amari' }"
    >
      <div class="wrap">
        <div v-reveal class="block__head">
          <div>
            <div class="t-eyebrow">{{ b.eyebrow }}</div>
            <h2 class="h2">{{ b.title }}</h2>
          </div>
          <router-link v-if="b.cta" :to="base + b.cta.to" class="block__more">{{ b.cta.text }} →</router-link>
        </div>

        <div v-if="b.layout === 'cards'" class="grid grid--cards">
          <component :is="item.to ? 'router-link' : 'div'" v-for="(item, i) in b.items" :key="item.key" v-reveal="(i % 3) * 70" :to="item.to ? base + item.to : undefined" class="card" :class="{ 'is-static': !item.to }">
            <img :src="item.img" :alt="item.name" loading="lazy">
            <div v-if="!item.hideCaption" class="card__body">
              <h3>{{ item.name }}</h3>
              <p v-if="item.text">{{ item.text }}</p>
              <span v-if="item.to" class="card__more">Подробнее →</span>
            </div>
          </component>
        </div>

        <div v-else class="grid grid--tiles">
          <component :is="item.to ? 'router-link' : 'div'" v-for="(item, i) in b.items" :key="item.key" v-reveal="(i % 4) * 60" :to="item.to ? base + item.to : undefined" class="tile" :class="{ 'is-static': !item.to }">
            <img :src="item.img" :alt="item.name" loading="lazy">
            <span>{{ item.name }}</span>
          </component>
        </div>
      </div>
    </section>

    <section class="cta">
      <div v-reveal class="wrap cta__inner">
        <div>
          <div class="t-eyebrow">Бронирование</div>
          <h2 class="h2 cta__title">Выберите даты и приезжайте</h2>
          <p class="cta__text">{{ info.address }}</p>
          <a :href="'tel:' + info.tel" class="cta__phone">{{ info.phone }}</a>
        </div>
        <div class="cta__actions">
          <router-link :to="base + '/booking/'" class="t-btn">Забронировать</router-link>
          <router-link :to="base + '/about/contacts/'" class="t-btn t-btn--ghost">Все контакты</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import Calendar from '../components/Calendar2'
import { siteInfo } from '../config/sites'
import { ABOUT } from '../config/content'
import { hasPage } from '../utils/photos'

const API = 'https://api.abaata.ru/list/'

export default {
  name: 'Home',
  components: { Calendar },
  data () {
    return {
      categories: [],
      restaurants: [],
      services: [],
      galleries: [],
      years: [
        { year: '1903', text: '«Приморская гостиница»' },
        { year: '1906', text: 'Меблированные комнаты «Принц Ольденбург»' },
        { year: '2009', text: 'современный корпус' }
      ],
      facts: {
        pitsunda: [
          { value: '300 м', text: 'собственный пляж' },
          { value: '5 га', text: 'охраняемая территория' },
          { value: '25×10 м', text: 'открытый бассейн' },
          { value: '5 этажей', text: 'здание в стиле лофт' }
        ],
        amari: [
          { value: '60', text: 'номеров с современным дизайном' },
          { value: '1-я', text: 'береговая линия в центре Гагры' },
          { value: 'SPA', text: 'финская сауна, хаммам, бассейн с морской водой' },
          { value: 'Roof', text: 'бассейн с подогревом и бар на крыше' }
        ]
      },
      fields: {
        abaata: { stay: 642, service: 643, gallery: 138 },
        pitsunda: { stay: 659, service: 673, gallery: 663 },
        amari: { stay: 681, service: 695, gallery: 686 }
      }
    }
  },
  computed: {
    site () {
      return this.$root.site === 'picunda' ? 'pitsunda' : this.$root.site
    },
    base () {
      return '/' + this.$root.site
    },
    info () {
      return siteInfo(this.site)
    },
    about () {
      return ABOUT[this.site] || []
    },
    hero () {
      return {
        abaata: { eyebrow: 'Гагра', title: 'Абаата' },
        pitsunda: { eyebrow: 'Пицунда', title: 'Абаата Пицунда' },
        amari: { eyebrow: 'Гагра · первая береговая линия', title: 'Бутик-отель в центре Гагры' }
      }[this.site]
    },
    aboutTitle () {
      return {
        abaata: 'Продолжатель традиций принца Ольденбургского',
        pitsunda: 'Абаата Пицунда',
        amari: 'Amari Hotel — новый бутик-отель класса делюкс'
      }[this.site]
    },
    factsList () {
      return this.facts[this.site] || []
    },
    field () {
      return this.fields[this.site]
    },
    stays () {
      const list = Array.isArray(this.categories) ? this.categories : Object.values(this.categories)
      if (this.site === 'abaata') {
        return list
          .filter(c => c.cf && c.cf[642])
          .map(c => ({ key: 'c' + c.id, name: c.name, img: c.cf[642], text: c.cf[135], to: '/offers/' + c.id }))
      }
      const rooms = []
      list.forEach(c => Object.values((c && c.numbers) || {}).forEach(n => {
        if (n.cf && n.cf[this.field.stay]) rooms.push({ key: 'n' + n.id, name: n.name, img: n.cf[this.field.stay], to: '/offer/' + n.id })
      }))
      return rooms.slice(0, 6)
    },
    dining () {
      return this.restaurants
        .filter(r => r.cf && r.cf[645])
        .map(r => ({ key: 'r' + r.id, name: r.name, img: r.cf[645], to: hasPage(r) ? '/restaurant/' + r.id : null }))
    },
    activities () {
      const field = this.field.service
      return this.services
        .filter(s => s.cf && s.cf[field])
        .map(s => ({ key: 's' + s.id, name: s.name.trim(), img: s.cf[field], to: hasPage(s) ? '/service/' + s.id : null }))
        .slice(0, 8)
    },
    gallery () {
      const field = this.field.gallery
      const list = Array.isArray(this.galleries) ? this.galleries : Object.values(this.galleries)
      return list
        .filter(g => g.id !== 70 && g.cf && g.cf[field] && g.cf[field][0])
        .map(g => ({
          key: 'g' + g.id,
          name: g.name,
          img: g.cf[field][0],
          text: g.short_html,
          to: '/gallery/' + g.id,
          hideCaption: this.site === 'amari' && g.name.trim().toLowerCase() === 'территория отеля'
        }))
    },
    blocks () {
      const abaata = this.site === 'abaata'
      const out = []
      if (this.stays.length) {
        out.push({
          key: 'stays', eyebrow: 'Размещение', layout: 'cards', items: this.stays,
          title: abaata ? 'Выберите формат проживания' : (this.site === 'amari' ? 'Выберите свой номер' : 'Номера у моря'),
          cta: { text: 'Все варианты', to: '/offers/' }
        })
      }
      if (abaata && this.dining.length) {
        out.push({
          key: 'dining', eyebrow: 'Рестораны и бары', title: 'Вкус Абхазии у моря', layout: 'tiles', dark: true,
          items: this.dining, cta: { text: 'Все рестораны', to: '/restaurants/' }
        })
      }
      if (this.activities.length) {
        out.push({
          key: 'activities', eyebrow: abaata ? 'Развлечения' : 'Услуги', layout: 'tiles', items: this.activities,
          dark: this.site === 'amari',
          title: abaata ? 'Отдых на каждый день' : (this.site === 'amari' ? 'Всё, что нужно, на одной территории' : 'Что есть на территории'),
          cta: { text: 'Все услуги', to: '/services/' }
        })
      }
      if (this.gallery.length) {
        out.push({
          key: 'gallery', eyebrow: 'Галерея', title: this.site === 'amari' ? 'Галерея' : 'Территория отеля', layout: 'cards', items: this.gallery, dark: this.site === 'pitsunda'
        })
      }
      return out
    }
  },
  mounted () {
    const load = (url, key) => axios.get(API + url)
      .then(r => { this[key] = r.data })
      .catch(() => {})
    const requests = []
    if (this.site === 'abaata') {
      requests.push(load('get-numbers', 'categories'))
      requests.push(load('get-lists?id=4&site=1', 'restaurants'))
      requests.push(load('get-lists?id=3&site=1', 'services'))
      requests.push(load('get-lists?id=5&site=1', 'galleries'))
    } else if (this.site === 'amari') {
      requests.push(load('get-numbers-a', 'categories'))
      requests.push(load('get-lists?id=56&site=1', 'services'))
      requests.push(load('get-lists?id=54&site=1', 'galleries'))
    } else {
      requests.push(load('get-numbers-p', 'categories'))
      requests.push(load('get-lists?id=52&site=1', 'services'))
      requests.push(load('get-lists?id=50&site=1', 'galleries'))
    }
    Promise.all(requests).then(() => document.dispatchEvent(new Event('seo:ready')))
  }
}
</script>

<style lang="scss">
/* встраивание рабочего календаря бронирования в первый экран */
.home .hero-book .calendar {
  position: static;
  left: auto;
  top: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  align-items: stretch;
}
.home .hero-book .calendar .calendar__container {
  float: none;
  flex: 1 1 190px;
  width: auto;
  margin: 0;
  border-color: rgba(255, 255, 255, .55);
  border-radius: var(--r);
  color: #fff;
}
.home .hero-book .calendar .calendar__container.__btn {
  flex: 0 1 190px;
  max-width: none;
  background: var(--acc);
  border-color: var(--acc);
}
@media (max-width: 500px) {
  .home .hero-book .calendar { flex-direction: column; }
  .home .hero-book .calendar .calendar__container,
  .home .hero-book .calendar .calendar__container.__btn { width: 100%; flex: none; margin: 0; }
}
</style>

<style lang="scss" scoped>
.wrap { max-width: 1440px; margin: 0 auto; padding: 0 var(--pad); }
.h2 { font-family: var(--head); font-weight: 500; font-size: clamp(28px, 4.2vw, 46px); line-height: 1.12; letter-spacing: 0; color: var(--fg); margin-bottom: 18px; }

/* ---------- первый экран ---------- */
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 28px;
  padding: 120px var(--pad) 70px;
  color: #fff;
  background-size: cover;
  background-position: center;
  &--abaata { background-image: url('../assets/img/new/hero-abaata.jpg'); background-position: 50% 62%; }
  &--pitsunda, &--picunda { background-image: url('../assets/img/new/hero-pitsunda.jpg'); }
  &--amari { background-image: url('../assets/img/new/hero-amari2.jpg'); background-position: 50% 56%; }
}
.hero__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(10, 8, 5, .5) 0%, rgba(10, 8, 5, .15) 38%, rgba(10, 8, 5, .7) 100%);
}
.hero__inner, .hero-book, .hero__scroll { position: relative; z-index: 2; }
.hero__inner { max-width: 880px; }
.hero__eyebrow { color: #e8d3a3; }
.hero--pitsunda .hero__eyebrow, .hero--picunda .hero__eyebrow { color: #bfeaf2; }
.hero__title {
  font-family: var(--head);
  font-weight: 400;
  font-size: clamp(44px, 8vw, 104px);
  line-height: 1;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.hero--amari .hero__eyebrow { color: #ead9b8; }
.hero--amari .hero__title { text-transform: none; letter-spacing: 0; font-size: clamp(40px, 6.4vw, 84px); line-height: 1.04; max-width: 14ch; }
.hero__lead { margin-top: 18px; max-width: 46ch; font-size: clamp(16px, 1.6vw, 20px); line-height: 1.5; opacity: .95; }
.hero-book {
  max-width: 980px;
  padding: 14px;
  background: rgba(15, 11, 6, .5);
  backdrop-filter: blur(8px);
  border-radius: var(--r);
}
.hero__scroll { align-self: center; font-size: 12px; letter-spacing: .24em; text-transform: uppercase; color: #fff !important; opacity: .8; }

/* ---------- о нас ---------- */
.about { padding: clamp(56px, 9vw, 110px) 0; background: var(--bg); }
.about__grid { display: grid; grid-template-columns: 1.4fr 1fr; gap: clamp(30px, 6vw, 90px); align-items: start; }
.about__text { white-space: pre-line; margin-top: 16px; color: var(--mut); font-size: 17px; line-height: 1.7; max-width: 64ch; }
.about__years, .about__facts { display: grid; gap: 22px; }
.about__facts { grid-template-columns: 1fr 1fr; }
.about__year, .about__fact { border-top: 2px solid var(--acc); padding-top: 14px; }
.about__year b, .about__fact b { display: block; font-family: var(--head); font-size: clamp(30px, 3.6vw, 44px); font-weight: 400; color: var(--acc); line-height: 1.1; }
.about__year span, .about__fact span { color: var(--mut); font-size: 15px; }

/* ---------- блоки ---------- */
.block { padding: clamp(50px, 8vw, 96px) 0; background: var(--bg); color: var(--fg); }
.block--dark { background: var(--dark); color: var(--on-dark); }
.block--dark .h2 { color: var(--on-dark); }
.block--amari-light { background: #eee7dc; color: #29251f; }
.block--amari-light .h2 { color: #29251f; }
.block__head { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 32px; flex-wrap: wrap; }
.block__more { font-size: 13px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; color: var(--acc-ui) !important; border-bottom: 1px solid currentColor; padding-bottom: 4px; }
.grid { display: grid; gap: clamp(14px, 2vw, 26px); }
.grid--cards { grid-template-columns: repeat(auto-fit, minmax(min(340px, 100%), 1fr)); }
.grid--tiles { grid-template-columns: repeat(auto-fit, minmax(min(230px, 100%), 1fr)); }

.card { display: flex; flex-direction: column; background: var(--card); color: var(--fg) !important; border-radius: var(--r); overflow: hidden; box-shadow: 0 1px 0 var(--line); transition: transform .3s ease, box-shadow .3s ease; }
.card:hover { transform: translateY(-4px); box-shadow: 0 18px 40px rgba(0, 0, 0, .14); }
.card img { width: 100%; aspect-ratio: 4 / 3; object-fit: cover; }
.card__body { padding: 20px 22px 24px; display: flex; flex-direction: column; gap: 8px; flex: 1; }
.card h3 { font-family: var(--head); font-weight: 500; font-size: 22px; }
.card p { color: var(--mut); font-size: 15px; line-height: 1.55; }
.card__more { margin-top: auto; padding-top: 10px; font-size: 12px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; color: var(--acc-ui); }

.tile { position: relative; display: block; aspect-ratio: 4 / 5; overflow: hidden; border-radius: var(--r); background: #000; }
.tile img { width: 100%; height: 100%; object-fit: cover; transition: transform .6s ease; }
.tile:hover img { transform: scale(1.06); }
.tile span { position: absolute; left: 0; right: 0; bottom: 0; padding: 56px 18px 18px; background: linear-gradient(transparent, rgba(0, 0, 0, .72)); color: #fff; font-family: var(--head); font-size: 20px; }

/* ---------- призыв к бронированию ---------- */
.cta { padding: clamp(46px, 7vw, 84px) 0; background: var(--acc-ui); color: var(--on-acc); }
.cta .t-eyebrow { color: rgba(255, 255, 255, .8); }
.cta__inner { display: flex; align-items: center; justify-content: space-between; gap: 30px; flex-wrap: wrap; }
.cta__title { color: #fff; margin-bottom: 10px; }
.cta__text { opacity: .9; max-width: 44ch; }
.cta__phone { display: inline-block; margin-top: 12px; font-size: 26px; font-weight: 700; color: #fff !important; }
.cta__actions { display: flex; gap: 12px; flex-wrap: wrap; }
.cta .t-btn { background: #fff; color: var(--acc) !important; border-color: #fff; }
.cta .t-btn--ghost { background: transparent; color: #fff !important; border-color: #fff; }

@media (max-width: 700px) {
  /* вертикальное фото Абаата: на узком экране показываем здание и кипарисы, а не ствол пальмы */
  .hero.hero--abaata { background-position: 68% 58%; }
  /* вертикальное фото Amari: по ширине экрана сверху, чтобы вывеска не оказалась под текстом */
  .hero.hero--amari { background-size: auto 100%; background-position: center; background-repeat: no-repeat; background-color: #14120f; padding-top: 310px; }
}
@media (max-width: 900px) {
  .about__grid { grid-template-columns: 1fr; }
  .hero { padding-top: 96px; padding-bottom: 90px; }
  .grid--tiles { grid-template-columns: repeat(2, 1fr); }
}
</style>
